import request from "./../utils/request";

export function getSettings() {
    return request.get(`/public/settings/get-all`);
}

export function updateSettings(data) {
    return request.put(`/settings`, data);
}

export function forceUpdateSettings(siteId, updatingSettingFields) {
    return request.post(`/settings/force-update-settings`, { siteId, updatingSettingFields });
}
